import React, { FC } from "react";
import { Row, Col, Typography, Button } from "antd";
import { CheckCircleTwoTone } from "@ant-design/icons";
import { useParams } from "react-router-dom";
import "./acceptanceAction.style.scss";
import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router-dom";
const AcceptanceAction: FC = () => {
  const { Title } = Typography;
  const navigate = useNavigate();
  const { activeSection, actionType }: any = useParams();

  // action : Transfer
  // activeSection : ske , product , ...
  //skuId

  return (
    <Row gutter={[0, 24]} justify="center">
      <Col span={24}>
        <div style={{ height: "calc(100vh - 130px)" }}>
          <div className="result">
            <div className="status">
              <CheckCircleTwoTone
                style={{ fontSize: 130 }}
                twoToneColor="#52c41a"
              />
            </div>
            <div className="title">
              <Title
                level={1}
                style={{
                  textAlign: "center",
                  lineHeight: "69px",
                  padding: "18px 0",
                }}
              >
                {actionType === "transfer" ? (
                  <FormattedMessage id="acceptanceAction.successTransfer" />
                ) : actionType === "exit" ? (
                  <FormattedMessage id="acceptanceAction.successTransfer" />
                ) : (
                  <FormattedMessage id="acceptanceAction.successTowarehouse" />
                )}
              </Title>
            </div>
            <Button
              type="primary"
              block
              size="large"
              onClick={() => navigate(`/panel/product`)}
              className="fw-bold"
            >
              <FormattedMessage id="acceptanceAction.changeToProduct" />
            </Button>
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default AcceptanceAction;
